var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnRepaired(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 100 16A8 8 0 008 0M6 11a1 1 0 110-2 1 1 0 010 2m0-4A1 1 0 116 5.001a1 1 0 01.001 2M10 11a1 1 0 110-2 1 1 0 010 2m0-4a1 1 0 11-.001-1.999 1 1 0 010 2",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgIcnRepaired;